"use client";

import { c as _c } from "react/compiler-runtime";
import WaveDropDeleteButton from "@/components/utils/button/WaveDropDeleteButton";
import VotingModal from "@/components/voting/VotingModal";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { useState } from "react";
import { SingleWaveDropContent } from "./SingleWaveDropContent";
import { SingleWaveDropInfoContainer } from "./SingleWaveDropInfoContainer";
import { SingleWaveDropInfoDetails } from "./SingleWaveDropInfoDetails";
import { WaveDropMetaRow } from "./WaveDropMetaRow";
import { WaveDropVoteSummary } from "./WaveDropVoteSummary";
interface SingleWaveDropInfoPanelProps {
  readonly drop: ExtendedDrop;
}
export const SingleWaveDropInfoPanel = t0 => {
  const $ = _c(30);
  const {
    drop
  } = t0;
  const [isVotingOpen, setIsVotingOpen] = useState(false);
  const {
    canDelete,
    canShowVote,
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  const isChatWave = drop.drop_type === ApiDropType.Chat;
  let t1;
  if ($[0] !== drop) {
    t1 = <div className="tw-mb-6"><SingleWaveDropContent drop={drop} /></div>;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== canShowVote || $[3] !== drop || $[4] !== isChatWave || $[5] !== isVotingEnded || $[6] !== isWinner) {
    t2 = !isChatWave && <div className="tw-mb-6 tw-flex tw-justify-center"><WaveDropVoteSummary drop={drop} isWinner={isWinner} isVotingEnded={isVotingEnded} canShowVote={canShowVote} onVoteClick={() => setIsVotingOpen(true)} /></div>;
    $[2] = canShowVote;
    $[3] = drop;
    $[4] = isChatWave;
    $[5] = isVotingEnded;
    $[6] = isWinner;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== drop || $[9] !== isWinner) {
    t3 = <WaveDropMetaRow drop={drop} isWinner={isWinner} />;
    $[8] = drop;
    $[9] = isWinner;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== drop || $[12] !== isChatWave) {
    t4 = !isChatWave && <div className="tw-mt-6"><SingleWaveDropInfoDetails drop={drop} /></div>;
    $[11] = drop;
    $[12] = isChatWave;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== canDelete || $[15] !== drop) {
    t5 = canDelete && drop.drop_type !== ApiDropType.Winner && <div className="tw-w-full tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pb-6 tw-pt-6"><WaveDropDeleteButton drop={drop} /></div>;
    $[14] = canDelete;
    $[15] = drop;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <SingleWaveDropInfoContainer><div className="tw-px-4 tw-pb-8 @[640px]:tw-px-8 @[640px]:tw-pb-10"><div className="tw-mx-auto tw-max-w-3xl">{t1}{t2}{t3}{t4}{t5}</div></div></SingleWaveDropInfoContainer>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== drop || $[24] !== isChatWave || $[25] !== isVotingOpen) {
    t7 = !isChatWave && <VotingModal drop={drop} isOpen={isVotingOpen} onClose={() => setIsVotingOpen(false)} />;
    $[23] = drop;
    $[24] = isChatWave;
    $[25] = isVotingOpen;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t6 || $[28] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  return t8;
};